export default __webpack_public_path__ + "static/media/4.f398e273.png";